import React, { createContext, useContext } from 'react';

/**
 * When SuperAdmin opens a company detail page, pages that normally wrap
 * CompanyAdminLayout render content only (embedded) for that company.
 */
const AdminEmbedContext = createContext({
  embedded: false,
  companyId: null,
  company: null,
  settingsMode: null, // 'system' | 'personal' | null (all)
  reportsMode: null, // 'ai' | null (all)
});

export function AdminEmbedProvider({
  children,
  companyId,
  company,
  settingsMode = 'system',
  reportsMode = 'ai',
}) {
  return (
    <AdminEmbedContext.Provider
      value={{
        embedded: true,
        companyId,
        company,
        settingsMode,
        reportsMode,
      }}
    >
      {children}
    </AdminEmbedContext.Provider>
  );
}

export function useAdminEmbed() {
  return useContext(AdminEmbedContext);
}
